export default function HeartIco() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 2.35615C5.8004 0.911603 3.79585 0.465177 2.29282 1.78794C0.789786 3.11071 0.578179 5.32229 1.75852 6.88675C2.73989 8.18745 5.70987 10.9308 6.68327 11.8187C6.79214 11.9181 6.8466 11.9677 6.91014 11.9872C6.96554 12.0043 7.02621 12.0043 7.08167 11.9872C7.14521 11.9677 7.19961 11.9181 7.30854 11.8187C8.28194 10.9308 11.2519 8.18745 12.2333 6.88675C13.4136 5.32229 13.2278 3.0968 11.6989 1.78794C10.1701 0.479092 8.19961 0.911603 7 2.35615Z"
        stroke="#667085"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
